import { FC } from "react";
import { Column, Row } from "../../../../components/containers";
import { usePopupStore, useThemeStore, useUserStore } from "../../../../stores";
import {
  AlignItems,
  JustifyContent,
} from "../../../../components/containers/types";
import StatusPicture from "../../../../components/status-picture";
import { UserStatus } from "../../../admin-panel/users/types";
import { Text } from "../../../../components/typography";
import { ChatState } from "../../types";
import { UserProfilePopup } from "../../../admin-panel/users/user";

const ChatBodyHeader: FC<ChatState> = ({ isSidePanel }) => {
  const theme = useThemeStore((s) => s.theme);
  const user = useUserStore((s) => s.user);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const onClick = (): void => {
    if (user)
      setPopupBody(<UserProfilePopup {...user} status={UserStatus.Online} />);
  };

  return (
    <Row
      style={{
        width: "calc(100% - 16px)",
        padding: "8px",
        borderBottom: `1px solid ${theme.iconLowOpacity}`,
      }}
      justifyContent={JustifyContent.Between}
    >
      <Row gap={8} style={{ cursor: "pointer" }} props={{ onClick }}>
        <StatusPicture
          src={user?.pic || ""}
          type={"small"}
          status={UserStatus.Online}
        />

        <Column alignItems={AlignItems.Start} gap={2}>
          <Text color={isSidePanel ? theme.textOnBg : theme.textOnOverlay}>
            {user?.fullname || ""}
          </Text>
          <Text color={theme.icon}>{user?.role || ""}</Text>
        </Column>
      </Row>
    </Row>
  );
};

export default ChatBodyHeader;
